export default [
    {   //包材管理
        path: "stocknotify/index",
        name: "StockNotifyIndex",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/stocknotify/index"),
    },
];